export const SAVE_USER_CONNECTED = 'SAVE_USER_CONNECTED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
